import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';
import {appHistory} from '../../../history';
import {store} from '../../../store';

import {BannerCueCards} from '../../glossary/layout/banner-cue-cards';

const CUE_CARDS_REACT_MOUNT_ID = 'users-cue-cards-react-mount';

export function mountUsersCueCards() {
    const mount = document.getElementById(CUE_CARDS_REACT_MOUNT_ID);

    if (mount) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <BannerCueCards />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            mount
        );
    }
}
